import { useCallback, useContext, useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export const ConfirmMessageModal1Id = 'BeforeLeavingMessageBox1';
export const ConfirmMessageModal2Id = 'BeforeLeavingMessageBox2';

const useConfirmExit = (confirmExit, when = true) => {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) {
      return;
    }

    const push = navigator.push;
    navigator.push = (...args) => {
      const result = confirmExit();
      if (result !== false) {
        push(...args);
      } else {
        navigator.lastPath = args[0];
      }
    };

    return () => {
      navigator.push = push;
    };
  }, [navigator, confirmExit, when]);
}

const usePrompt = (isPrevented, when = true, callback) => {
  const confirmExit = useCallback(() => {
    document.getElementById(ConfirmMessageModal1Id).hidden = false;
    return isPrevented;
  }, [isPrevented]);

  useConfirmExit(confirmExit, when);
}

export default usePrompt;